<template>
  <div class="animated fade-in">
    <h1 class="display-4 font-weight-lighter">
      Document Folders
    </h1>
    <manage-root-document-folders class="my-4"></manage-root-document-folders>
  </div>
</template>

<script>

import ManageRootDocumentFolders from "../../components/documents/ManageRootDocumentFolders";

export default {
  name: "DocumentFolderManage",
  components: {ManageRootDocumentFolders},
  data() {
    return {};
  },
  methods: {},
};
</script>
